const t = "product-compare";
class o {
  constructor() {
    this.productCompareHandles = [], this.init(), this.LIMIT = 3, window.addEventListener("storage", (e) => {
      e.key === t && this.init();
    });
  }
  init() {
    this.productCompareHandles = JSON.parse(
      localStorage.getItem(t) || "[]"
    );
  }
  emit() {
    const e = new StorageEvent("storage", {
      key: t,
      oldValue: this.productCompareHandles.toString(),
      newValue: this.productCompareHandles.toString()
    });
    window.dispatchEvent(e);
  }
  add(e) {
    this.productCompareHandles = Array.from(
      new Set(
        [e, ...this.productCompareHandles.reverse()].slice(0, this.LIMIT)
      )
      // Keep track of 3 products to compare
    ), localStorage.setItem(
      t,
      JSON.stringify(this.productCompareHandles)
    ), this.emit();
  }
  hasAny() {
    return !!this.productCompareHandles.length;
  }
  isFull() {
    return this.productCompareHandles.length === this.LIMIT;
  }
  get() {
    return this.productCompareHandles;
  }
  clear() {
    localStorage.removeItem(t), this.productCompareHandles = [], this.emit();
  }
  remove(e) {
    this.productCompareHandles = this.productCompareHandles.filter(
      (r) => r !== e
    ), localStorage.setItem(
      t,
      JSON.stringify(this.productCompareHandles.reverse())
    ), this.emit();
  }
  list() {
    return this.productCompareHandles;
  }
}
const a = new o();
export {
  a as p
};
